<section class="small-info">
  <img src="../../../../assets/report_v2/info-blue.svg" alt="info">
  <section>
    <h4>{{ title }}</h4>
    <p>
      {{ description }}
    </p>
  </section>
</section>